var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9", attrs: { id: "main" } }, [
              _c("div", { staticClass: "container shortcode travel-ideas" }, [
                _c("h1", { staticClass: "idea-title" }, [
                  _vm._m(0),
                  _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale])),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "booking-information sdr-box" },
                [
                  _c("center", [
                    _c("h4", {
                      domProps: {
                        innerHTML: _vm._s(_vm.add_h4_1[_vm.getCurrentLocale]),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", { staticClass: "table table-bordered" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("th", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_th_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("th", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_th_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("th", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_th_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_th_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("th", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("th", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_th_5[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("th", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_th_6[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tbody", [
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_1_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_1_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_1_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_1_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_2_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_2_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_2_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_2_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_3_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_3_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_3_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_3_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_4_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_4_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_4_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_4_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_5_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_5_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_5_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_5_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_6_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_6_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_6_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_6_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_7_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_7_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_7_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_7_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_8_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_8_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_8_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_8_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_9_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_9_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_9_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_9_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_10_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_10_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_10_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_10_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_11_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_11_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_11_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_11_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "th",
                            {
                              attrs: { scope: "row" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.add_row_12_1[_vm.getCurrentLocale]
                                ),
                              },
                            },
                            [_c("b")]
                          ),
                          _vm._v(" "),
                          _c("td"),
                          _vm._v(" "),
                          _c("td"),
                          _vm._v(" "),
                          _c("td"),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_13_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_13_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_13_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_13_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_14_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_14_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_14_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_14_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_15_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_15_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_15_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_15_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_16_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_16_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_16_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_16_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_17_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td"),
                          _vm._v(" "),
                          _c("td"),
                          _vm._v(" "),
                          _c("td"),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_18_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_18_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_18_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_18_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_19_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_19_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_19_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_19_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_20_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_20_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_20_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_20_4[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_21_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_22_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_22_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_22_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_23_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_23_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_23_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_24_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_24_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_24_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_25_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_25_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_25_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_26_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_26_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_26_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                        ]),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", {
                            attrs: { scope: "row" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_27_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_28_1[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_28_2[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.add_row_28_3[_vm.getCurrentLocale]
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", [_vm._v(" ")]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.add_p_1[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.add_p_2[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.add_p_3[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.add_p_31[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.add_p_4[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _c("br"),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.add_footer_1[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", [_vm._v("Update: 22.03.2021")]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
      _vm._v(" "),
      _c("td", [_vm._v(" ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }